<div class="container p-0">
  <div
    style="background: #126e51; padding-right: 10px; padding-top: 2px"
    class="d-flex justify-content-between"
  >
    <h3 class="text-heading ml-2">Bet Slip</h3>
    <span (click)="closeDialog()" class="text-light h3">&times;</span>
  </div>

  <!-- <div class="d-flex justify-content-between">
    <div>
        <div>{{data.market_name}}</div>
        <div>{{data.type}}</div>
    </div>
    <div class="d-flex-column">
      <h5 class="mb-1 text-dark">{{data.type}}</h5>
      <input type="text" readonly [(ngModel)]="price" class="form-control form-control-sm">
    </div>
    <div>
      <h5 class="mb-1 text-dark">Stack</h5>
      <div class="d-flex">
        <a (click)="decre()"><span style="height: 35px;" class="btn btn-primary material-symbols-outlined">remove</span></a>
        <input type="number" style=" color: white;" (ngModelChange)="calculate()" [autofocus]="true"  [(ngModel)]="count" placeholder="0"  pattern="[0-9]*" step="1" class="form-control form-control-sm">
        <a (click)="incre()"><span style="height: 35px;" class="btn btn-primary material-symbols-outlined">add</span></a>
      </div>
    </div>
  </div> -->
  <div
    [class.bg-pink]="data.type == 'Lay'"
    [class.bg-blue]="data.type == 'Back'"
    class="bg-default mt-3"
  >
    <div>
      <div class="p-1">
        <div class="text-grey">{{ data.market_name }}</div>
        <div class="mb-2 text-grey">{{ data.type }}</div>
      </div>
      <div class="p-1">
        <h5 style="display: flex; justify-content: space-between">
          <span
            style="
              display: block;
              width: 16em;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            class="text-dark"
            >{{ data.runner_name }}</span
          >
          <small style="float: right" class="text-dark">{{
            data.value.price
          }}</small>
        </h5>
        <div class="d-flex justify-content-between">
          <!-- <a (click)="decre()"><span style="height: 35px;" class="btn btn-primary material-symbols-outlined">remove</span></a> -->
          <div>
            <input
              type="number"
              style="color: white; background: #444"
              (ngModelChange)="calculate()"
              [autofocus]="true"
              [(ngModel)]="count"
              placeholder="Amount"
              pattern="[0-9]*"
              step="1"
              class="form-control form-control-sm"
            />
          </div>
          <!-- <a (click)="incre()"><span style="height: 35px;" class="btn btn-primary material-symbols-outlined">add</span></a> -->
          <div
            *ngIf="finalLoss != 0 && data.type == 'Back'"
            class="text-dark"
            style="font-size: 14px"
          >
            Profit <br />
            {{ finalProfit | number : ".2-2" }}
          </div>
          <div
            *ngIf="finalProfit != 0 && data.type == 'Lay'"
            class="text-dark"
            style="font-size: 14px"
          >
            Profit <br />
            {{ finalProfit | number : ".2-2" }}
          </div>
        </div>
      </div>
    </div>
    <div>
      <!--<div class="mt-3 d-flex flex-wrap justify-content-center align-content-center rounded  bg-black" style="height:80px"> 
            <div class="p-1 font-weight-bold m-1 bg-yellow rounded-pill p-2" (click)="incre(100)">100</div>
           <div class="p-1 font-weight-bold m-1 bg-yellow rounded-pill p-2" (click)="incre(200)">200</div>
           <div class="p-1 font-weight-bold m-1 bg-yellow rounded-pill p-2" (click)="incre(500)">500</div>
      <div class="p-1 font-weight-bold m-1 bg-yellow rounded-pill p-2" (click)="incre(100)">100</div>
        <div class="p-1 font-weight-bold m-1 bg-yellow rounded-pill p-2" (click)="incre(300)">300</div>
        <div class="p-1 font-weight-bold m-1 bg-yellow rounded-pill p-2" (click)="incre(500)">500</div>
        <div class="p-1 font-weight-bold m-1 bg-yellow rounded-pill p-2" (click)="incre(1000)">1000</div>
        <div class="p-1 font-weight-bold m-1 bg-yellow rounded-pill p-2" (click)="incre(2500)">2500</div>
        <div class="p-1 font-weight-bold m-1 bg-yellow rounded-pill p-2" (click)="incre(5000)">5000</div>
      </div>-->
      <div class="p-1">
        <table class="mytable w-100">
          <tr >
            <td >
              <div
                class="btn text-dark mytable-tr"
                (click)="incre(100)"
              >
                +100
              </div>
            </td>
            <td >
              <div
                class="btn text-dark mytable-tr"
                (click)="incre(300)"
              >
                +300
              </div>
            </td>
            <td >
              <div
                class="btn text-dark mytable-tr"
                (click)="incre(500)"
              >
                +500
              </div>
            </td>
          </tr>
          <tr >
            <td >
              <div
                class="btn text-dark mytable-tr"
                (click)="incre(1000)"
              >
                +1000
              </div>
            </td>
            <td >
              <div
                class="btn text-dark mytable-tr"
                (click)="incre(5000)"
              >
                +5000
              </div>
            </td>
            <td >
              <div
                class="btn text-dark mytable-tr"
                (click)="incre(10000)"
              >
                +10000
              </div>
            </td>
          </tr>
        </table>
      </div>
    <!-- </div>  -->
      <!-- <div class="p-1">
        <table class="mytable w-100">
          <tr *ngFor="let row of buttonData">
            <td *ngFor="let button of row">
              <div
                class="btn text-dark mytable-tr"
                (click)="incre(button.price_value)"
              >
                {{ button.price_label }}
              </div>
            </td>
          </tr>
        </table>
      </div> -->

      <div class="d-flex mt-3 justify-content-between">
        <!-- <button style="background: #fa7072;" (click)="dismiss()" class="btn btn-outline mr-1">Cancel</button>
        <button style="background: #fa7072;" (click)="clear()" class="btn btn-outline mr-1">Clear</button> -->
        <!--    <button class="btn btn-warning" (click)="submit()" [disabled]="submitted_disabled">PLACE BET</button>-->
        <button
          class="btn btn-block btn-green text-light w-100"
          (click)="submit()"
          [disabled]="count <= 0 || submitted_disabled"
        >
          Place bet
        </button>
      </div>
    </div>
  </div>

  <div
    class="d-flex mt-3 justify-content-between p-2"
    *ngIf="
      this.data.m_type != 'session' &&
      this.data.m_type != 'meter' &&
      this.data.m_type != 'fancy' &&
      !this.data.m_type.toLowerCase().includes('soccer_under')
    "
  >
    <div>
      <span class="team-name">{{ data.runner_name }}</span
      ><br />
      <span class="team-name">{{
        ["Draw", "The Draw"].includes(data.runner_name)
          ? other_runner_name[0]
          : other_runner_name
      }}</span
      ><br />
      <span *ngIf="data.enable_draw" class="team-name">{{
        ["Draw", "The Draw"].includes(data.runner_name)
          ? other_runner_name[1]
          : "Draw"
      }}</span>
    </div>
    <div class="text-right">
      <span
        [class.text-success]="data.type == 'Back'"
        [class.text-danger]="data.type == 'Lay'"
        >{{
          (data.type == "Back" ? finalProfit : finalLoss) | number : ".2-2"
        }}</span
      ><br />
      <span
        [class.text-danger]="data.type == 'Back'"
        [class.text-success]="data.type == 'Lay'"
        >{{
          (data.type == "Lay" ? finalProfit : finalLoss) | number : ".2-2"
        }}</span
      ><br />
      <span
        *ngIf="data.enable_draw"
        [class.text-danger]="data.type == 'Back'"
        [class.text-success]="data.type == 'Lay'"
        >{{
          (data.type == "Lay" ? finalProfit : finalLoss) | number : ".2-2"
        }}</span
      >
    </div>
  </div>
</div>
<app-timer-overlay *ngIf="showTimerOverlay"></app-timer-overlay>
